<template lang="pug">
  div
    Row
      Col(:lg="8" :md="12")
        Card.dashBoardCard
            PieChartWrapper(
                :chartType="'cacheStatusPieChart'"
                :chartTitle="$t('dashboard.cacheRatioText')"
                :topNSize="2"
                :chartHeight="chartHeight"
                :numeralFormat="'0.00b'"
                :titleDisplay="false"
                :withCard="false"
                :useGuage="true"
                :pieBackgroundColors="[[colorScheme.blue.fill]]"
                :legendDisplay="false"
                :withPercentageText="true"
                :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                )
      Col(:lg="16" :md="12")
        Card.dashBoardCard
            BarChartWrapper(
                :chartType="'servicegroupBarChartByCacheStatus'"
                :useBackendDatasetLabel="true"
                :chartTitle="$t('dashboard.requestCount')"
                :numeralFormat="'0.00b'"
                :topNSize="3"
                :chartHeight="chartHeight"
                :withCard="false"
                :direction="direction"
                :barBorderColors="[colorScheme.blue.border]"
                :barBackgroundColors="[colorScheme.blue.fill]"
                :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                )
    Row
      Col(:lg="24" :md="24")
        Card.dashBoardCard
            BarChartWrapper(
                :chartType="'domainBarChartByCacheStatus'"
                :useBackendDatasetLabel="true"
                :chartTitle="$t('dashboard.requestCount')"
                :numeralFormat="'0.00b'"
                :topNSize="10"
                :chartHeight="chartHeight"
                :withCard="false"
                :direction="direction"
                :barBorderColors="[colorScheme.blue.border]"
                :barBackgroundColors="[colorScheme.blue.fill]"
                :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                )
    Row
      Col(:lg="12" :md="24")
        Card.dashBoardCard
            BarChartWrapper(
                :chartType="'uriBarChartByCached'"
                :chartDataSetLabel="[$t('dashboard.cachedUri')]"
                :numeralFormat="'0.00b'"
                :topNSize="10"
                :chartHeight="chartHeight"
                :withCard="false"
                :direction="direction"
                :barBorderColors="[colorScheme.blue.border]"
                :barBackgroundColors="[colorScheme.blue.fill]"
                :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                )
      Col(:lg="12" :md="24")
        Card.dashBoardCard
            BarChartWrapper(
                :chartType="'uriBarChartByUnCached'"
                :chartDataSetLabel="[$t('dashboard.unCachedUri')]"
                :numeralFormat="'0.00b'"
                :topNSize="10"
                :chartHeight="chartHeight"
                :withCard="false"
                :direction="direction"
                :barBorderColors="[colorScheme.blue.border]"
                :barBackgroundColors="[colorScheme.blue.fill]"
                :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                )

</template>
<script>
import LineChartWrapper from "@/components/dashboard/LineChartWrapper";
import BarChartWrapper from "@/components/dashboard/BarChartWrapper";
import SingleNumWrapper from "@/components/dashboard/SingleNumWrapper";
import PieChartWrapper from "@/components/dashboard/PieChartWrapper";

import colorScheme from "@/data/colorScheme";
export default {
    components: {
        LineChartWrapper,
        BarChartWrapper,
        SingleNumWrapper,
        PieChartWrapper
    },
    props: {
        groupNames: {
            type: Array,
            default: () => []
        },
        serviceGroupNames: {
            type: Array,
            default: () => []
        },
        domains: {
            type: Array,
            default: () => []
        },
        origins: {
            type: Array,
            default: () => []
        },
        edgeNames: {
            type: Array,
            default: () => []
        },
        dateRange: {
            type: String,
            default: "1"
        },
        customTimeRange: {
            type: Array,
            default: () => ["", ""]
        },
        direction: {
            type: String,
            default: "vertical"
        }
    },
    data() {
        return {
            colorScheme: colorScheme,
            chartHeight: 280
        };
    }
};
</script>
<style lang="less" scoped>
.dashBoardCard {
    margin: 6px;
    min-height: 450px;
    height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage/AccelerationContent.vue